export interface TabRouteInfo {
  title: string;
  icon: string;
}

const TAB_ROUTE_MAP: Record<string, TabRouteInfo> = {
  '/home': { title: 'Dashboard', icon: 'dashboard' },
  '/veiculo': { title: 'Veículos', icon: 'car' },
  '/locatarios': { title: 'Locatários', icon: 'user' },
  '/filiais': { title: 'Unidades', icon: 'building' },
  '/servico': { title: 'Serviços', icon: 'tools' },
  '/peca': { title: 'Peças', icon: 'cogs' },
  '/prestador-servico': { title: 'Prestadores', icon: 'user-tie' },
  '/usuarios': { title: 'Usuários', icon: 'user' },
  '/categoria': { title: 'Categorias', icon: 'tag' },
  '/cadastros/financeiro/bancos': { title: 'Bancos', icon: 'university' },
  '/modelo-contrato': { title: 'Contrato', icon: 'file-contract' },
  '/locacao': { title: 'Locações', icon: 'handshake' },
  '/vistoria': { title: 'Vistorias', icon: 'check-circle' },
  '/mapa-veiculos': { title: 'Mapa de Veículos', icon: 'map' },
  '/manutencoes': { title: 'Manutenções', icon: 'tools' },
  '/plano-manutencao': { title: 'Plano de Manutenção', icon: 'calendar-check' },
  '/troca-de-oleo': { title: 'Troca de Óleo', icon: 'oil-can' },
  '/estoque': { title: 'Estoque', icon: 'inventory' },
  '/multas': { title: 'Multas', icon: 'invoice-dollar' },
  '/pagamento': { title: 'Pagamentos', icon: 'money' },
  '/lancamento': { title: 'Lançamentos', icon: 'invoice' },
  '/notas-fiscais': { title: 'Notas Fiscais', icon: 'file-contract' },
  '/relatorio-geral': { title: 'Relatório Geral', icon: 'chart' },
  '/relatorio-financeiro': { title: 'Relatório Financeiro', icon: 'money' },
  '/relatorio-comissoes': { title: 'Comissões', icon: 'money' },
  '/auditoria': { title: 'Auditoria', icon: 'history' },
  '/ajuda': { title: 'Central de Ajuda', icon: 'help' },
  '/suporte': { title: 'Suporte', icon: 'whatsapp' },
  '/planos': { title: 'Planos', icon: 'diamond' },
  '/minha-conta': { title: 'Minha Conta', icon: 'user' },
  '/notifications': { title: 'Notificações', icon: 'bell' },
  '/editor-contrato': { title: 'Editor de Contrato', icon: 'file-contract' },
  '/app-locatario': { title: 'APP Locatário', icon: 'mobile' },
  '/pesquisas': { title: 'Pesquisas', icon: 'chart' },
  '/empresas': { title: 'Empresas', icon: 'building' },
  '/meu-site': { title: 'Meu Site', icon: 'globe' },
};

export function getTabInfoFromPath(pathname: string): TabRouteInfo | null {
  // Tenta match exato primeiro
  if (TAB_ROUTE_MAP[pathname]) {
    return TAB_ROUTE_MAP[pathname];
  }

  // Tenta match pelo path base (sem query params)
  const basePath = pathname.split('?')[0];
  if (TAB_ROUTE_MAP[basePath]) {
    return TAB_ROUTE_MAP[basePath];
  }

  // Tenta match por prefixo (rotas dinâmicas como /locacao/123/editar)
  const segments = basePath.split('/').filter(Boolean);
  for (let i = segments.length; i >= 1; i--) {
    const candidate = '/' + segments.slice(0, i).join('/');
    if (TAB_ROUTE_MAP[candidate]) {
      return TAB_ROUTE_MAP[candidate];
    }
  }

  return null;
}

export default TAB_ROUTE_MAP;
